module.exports = __webpack_public_path__ + "img/core-advantages-5.62fabec8.svg";